import type { ApiEndpoints, HttpClient } from "./http-common"
import { createHttpClient } from "./http-common"

/**
 * Factory for creating API service instances
 * This class provides a static method to create instances of API services
 * with a pre-configured HTTP client.
 */
export class ApiServiceFactory {
  /**
   * Create a service instance for a specific API
   * @param ServiceClass - The service class
   * @param serviceKey - The service key (bdm, box, bk3, etc.)
   * @param config - Optional HTTP client configuration
   */
  static createService<T>(
    ServiceClass: new (httpClient: HttpClient) => T,
    serviceKey: string,
    config?: RequestInit,
  ): T {
    const httpClient = createHttpClient(serviceKey as keyof ApiEndpoints, config)
    return new ServiceClass(httpClient)
  }
}

export default ApiServiceFactory
